<script>
import GeoTIFF from "ol/source/GeoTIFF";

export default {
  name: "ol-source-geotiff",

  inject: ["getLayer"],

  props: {
    layers: {
      type: String,
      required: true,
    },

    filter: {
      type: String,
    },

    crossOrigin: {
      type: String,
      default: "Anonymous",
    },
    styles: {
      type: String,
      required: "",
    },
  },

  watch: {
    filter(cqlFilter) {
      if (cqlFilter.length) {
        const params = this.tilewms.getParams();
        this.tilewms.updateParams({
          ...params,
          styles: this.styles,
          CQL_FILTER: cqlFilter,
        });
      }
    },

    layers(layers) {
      this.tilewms.updateParams({
        layers,
        styles: this.styles,
        VERSION: "1.1.0",
        FORMAT: "image/png",
      });
    },
  },

  data() {
    return {
      tilewms: null,
    };
  },

  created() {
    const params = {
      layers: this.layers,
      VERSION: "1.1.0",
      FORMAT: "image/png",
      STYLES: this.styles,
      // exceptions: 'application/vnd.ogc.se_inimage'
    };
    this.filter && (params.CQL_FILTER = this.filter);
    this.tilewms = new GeoTIFF({
      wrapX: true,
      normalize: false,
      sources: [
        {
          url:'https://s2downloads.eox.at/demo/EOxCloudless/2020/rgbnir/s2cloudless2020-16bits_sinlge-file_z0-4.tif',
          // url: "http://152.136.235.43:8080/geoserver/henan/wms?SERVICE=WMS&VERSION=1.1.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&layers=henan%3Aly_603_9999_3104000813_20240522_tif&WIDTH=256&HEIGHT=256&SRS=EPSG%3A4326&BBOX=114.752197265625%2C34.771728515625%2C114.76318359375%2C34.78271484375", // 替换为实际 GeoTIFF 文件的 URL
        },
      ],
    });
    this.getLayer((layer) => {
      layer.setSource(this.tilewms);
    });
  },

  beforeDestroy() {
    this.tilewms = null;
  },

  render() {
    return null;
  },
};
</script>
